// PL + EN translations for LK LOG site
export const translations = {
  pl: {
    nav: {
      home: "Start",
      about: "O nas",
      services: "Usługi",
      industries: "Branże",
      adr: "ADR",
      solutio: "Solutio",
      contact: "Kontakt",
      cta: "Wyceń transport",
    },
    hero: {
      eyebrow: "Logistyka premium · Polska i Europa",
      tagline: "Zawsze na właściwym kursie",
      title: "Twój kompleksowy partner logistyczny",
      subtitle:
        "Transport, logistyka, doradztwo ADR i wsparcie prawne dla firm produkcyjnych, przemysłowych oraz partnerów wymagających terminowej i elastycznej obsługi dostaw w Polsce i Europie.",
      cta1: "Wyceń transport",
      cta2: "Porozmawiaj o współpracy",
      usp1: "Transport krajowy i międzynarodowy",
      usp2: "Własna flota i sieć przewoźników kontraktowych",
      usp3: "Obsługa klientów produkcyjnych i przemysłowych",
      usp4: "Doradztwo ADR / DGSA",
    },
    anniversary: {
      label: "2020 — 2026",
      title_pre: "Dziękujemy za",
      title_big: "6 lat",
      title_post: "zaufania i współpracy",
      line1: "Twój cel — nasza misja",
      line2: "Transport — to my",
      line3: "Razem tworzymy dobry zespół",
    },
    about: {
      label: "O firmie",
      title: "Logistyka oparta na\u00A0doświadczeniu, odpowiedzialności i\u00A0partnerstwie",
      p1: "LK LOG to zaufany partner logistyczny, specjalizujący się w kompleksowej organizacji transportu na terenie Polski i całej Europy. Od 2020 roku rozwijamy własną flotę, zaplecze operacyjne oraz sieć współpracujących przewoźników, zapewniając klientom niezawodną obsługę zarówno w modelu stałym, jak i przy zleceniach nieregularnych, sezonowych oraz pilnych.",
      p2: "Za firmą stoi zespół z ponad 30-letnim doświadczeniem w branży transportowej, magazynowej i operacyjnej. Łączymy praktyczną wiedzę biznesową z nowoczesnym podejściem do zarządzania transportem, dzięki czemu wspieramy klientów nie tylko jako wykonawca przewozów, ale jako realny partner w organizacji łańcucha dostaw.",
      stat1_v: "2020",
      stat1_l: "Od tego roku rozwijamy struktury LK LOG",
      stat2_v: "30+",
      stat2_l: "Lat doświadczenia zespołu w transporcie i logistyce",
      stat3_v: "PL · EU",
      stat3_l: "Polska i Europa — pełne pokrycie operacyjne",
      stat4_v: "24/7",
      stat4_l: "Dedykowana obsługa operacyjna",
    },
    capabilities: {
      label: "Możliwości operacyjne",
      title: "Zaplecze transportowe gotowe na stałą obsługę i szybkie reakcje",
      subtitle:
        "Dysponujemy skalowalnym zapleczem operacyjnym, które pozwala nam obsługiwać zarówno regularne łańcuchy dostaw, jak i transporty niestandardowe, projektowe oraz pilne zlecenia ad hoc.",
      c1_t: "Własna flota operacyjna",
      c1_b1: "41 zestawów 13,6 m",
      c1_b2: "~70% to naczepy typu mulda",
      c1_b3: "11 busów 8/10 EP",
      c1_b4: "Sezonowo naczepy typu wywrotka",
      c2_t: "Sieć przewoźników kontraktowych",
      c2_d: "Współpracujemy z wyselekcjonowaną grupą przewoźników partnerskich, dzięki czemu możemy szybko zwiększać dostępność pojazdów i utrzymywać ciągłość obsługi również w okresach wzmożonych wolumenów.",
      c3_t: "Centralne zarządzanie operacyjne",
      c3_d: "Każde zlecenie nadzoruje dedykowany zespół operacyjny. Klient otrzymuje jeden punkt kontaktu, bieżący nadzór i jednolity standard obsługi.",
    },
    industries: {
      label: "Obsługiwane branże",
      title: "Rozumiemy potrzeby produkcji, przemysłu i dystrybucji",
      subtitle:
        "Obsługujemy firmy, które potrzebują partnera rozumiejącego specyfikę procesów produkcyjnych, okien załadunkowych, buforowania zapasów, transportów objętościowych i dostaw realizowanych w ścisłych harmonogramach.",
      items: [
        { t: "Automotive", d: "Komponenty, części, podzespoły, dostawy just-in-time i just-in-sequence." },
        { t: "Przemysł ciężki i hutniczy", d: "Kręgi stalowe, elementy konstrukcyjne, ładunki wielkogabarytowe." },
        { t: "Rolnictwo i agro", d: "Nawozy, zboża, materiały sypkie i workowane." },
        { t: "Spożywcza i napojowa", d: "Produkty suche, półprodukty, opakowania." },
        { t: "FMCG", d: "Ładunki paletowe, szybki obrót i terminowość." },
        { t: "Meble i gabaryty", d: "Dostawy do centrów dystrybucyjnych i punktów handlowych." },
        { t: "Import z Azji", d: "Kontenery, przeładunki portowe, dystrybucja krajowa i UE." },
        { t: "Opakowania i tworzywa", d: "Stała obsługa linii produkcyjnych i magazynów." },
      ],
    },
    services: {
      label: "Usługi",
      title: "Więcej niż transport",
      s1_t: "Transport i spedycja",
      s1_d: "Organizujemy transport krajowy i międzynarodowy, zapewniając elastyczne modele współpracy dopasowane do potrzeb klientów produkcyjnych, handlowych i przemysłowych.",
      s2_t: "Logistyka operacyjna",
      s2_d: "Pomagamy w planowaniu i realizacji łańcucha dostaw, koordynacji załadunków, dystrybucji oraz obsłudze transportów niestandardowych.",
      s3_t: "Doradztwo ADR / DGSA",
      s3_d: "Oferujemy wsparcie w zakresie przewozu towarów niebezpiecznych, dokumentacji, audytów, raportów rocznych ADR oraz wdrażania procedur i szkoleń.",
      s4_t: "Obsługa prawna biznesu",
      s4_d: "W ramach struktury LK LOG działa kancelaria Solutio, która wspiera przedsiębiorstwa w zakresie obsługi prawnej, windykacji, restrukturyzacji, ochrony majątku i spraw formalnych.",
    },
    adr: {
      label: "ADR · DGSA",
      title: "Doradztwo ADR — bezpieczeństwo pod pełną kontrolą",
      body:
        "Jako certyfikowany doradca DGSA oferujemy pełne wsparcie w zakresie organizacji przewozu towarów niebezpiecznych. Pomagamy ograniczać ryzyko, zapewnić zgodność z aktualnymi przepisami i uporządkować dokumentację wymaganą w codziennej działalności operacyjnej.",
      b1: "Doradztwo przy przewozie towarów niebezpiecznych",
      b2: "Raporty roczne ADR, dokumentacja i audyty",
      b3: "Szkolenia i wdrożenia procedur",
      b4: "Minimalizacja ryzyka i zgodność z przepisami",
      cta: "Zapytaj o wsparcie ADR",
    },
    solutio: {
      label: "Solutio",
      title: "Logistyka i prawo w jednej strukturze",
      body:
        "Solutio to kancelaria działająca w strukturze biznesowej LK LOG. Dzięki temu nasi klienci mogą korzystać nie tylko z transportu i logistyki, ale także z praktycznego wsparcia w obszarach formalnych i prawnych, które wpływają na bezpieczeństwo operacyjne firmy.",
      b1: "Obsługa prawna firm",
      b2: "Windykacja i dochodzenie należności",
      b3: "Restrukturyzacja i doradztwo w sytuacjach kryzysowych",
      b4: "Ochrona majątku i reprezentacja",
      cta: "Poznaj wsparcie Solutio",
    },
    why: {
      label: "Dlaczego LK LOG",
      title: "Dlaczego firmy wybierają LK LOG",
      items: [
        { t: "Elastyczność i dostępność floty", d: "Łączymy własne zaplecze transportowe z siecią sprawdzonych przewoźników kontraktowych. Szybko reagujemy na zmieniające się potrzeby i skalujemy obsługę bez utraty jakości." },
        { t: "Pewność i terminowość", d: "Każde zlecenie realizujemy według ustalonych standardów operacyjnych, z bieżącym nadzorem i odpowiedzialnością za proces od początku do końca." },
        { t: "Kompleksowość usług", d: "Transport, logistyka, ADR i obsługa prawna w jednej strukturze — mniej ryzyk, mniej punktów styku i większa przewidywalność współpracy." },
        { t: "Zrozumienie środowiska produkcyjnego", d: "Dostosowujemy się do rytmu pracy zakładów, wymagań okien załadunkowych oraz modeli dostaw JIT i JIS." },
        { t: "Partnerskie podejście", d: "Budujemy relacje długoterminowe. Jesteśmy bezpośredni, transparentni i nastawieni na rozwiązania, które realnie wspierają biznes klienta." },
      ],
    },
    process: {
      label: "Proces",
      title: "Jak wygląda współpraca z LK LOG",
      steps: [
        { t: "Analiza potrzeb", d: "Poznajemy specyfikę ładunku, częstotliwość dostaw, kierunki i oczekiwania operacyjne." },
        { t: "Dobór modelu obsługi", d: "Dopasowujemy flotę, harmonogram, sposób raportowania i poziom zaangażowania operacyjnego." },
        { t: "Realizacja i nadzór", d: "Prowadzimy transport pod bieżącą kontrolą zespołu operacyjnego i zapewniamy kontakt na każdym etapie." },
        { t: "Rozwój współpracy", d: "Optymalizujemy model działania wraz ze wzrostem wolumenów, sezonowością i zmianami po stronie klienta." },
      ],
    },
    investment: {
      label: "Inwestycja · Rozwój",
      title: "Rozwijamy własne centrum logistyczne",
      body1:
        "W ramach długoterminowej strategii planujemy budowę centrum logistycznego w regionie Ciechocinka. Projekt obejmuje nowoczesną powierzchnię magazynową, strefę przeładunkową oraz możliwość obsługi modeli buforowania i dystrybucji dla firm produkcyjnych.",
      body2:
        "To kierunek rozwoju dla klientów, którzy chcą konsolidować transport i logistykę u jednego partnera i budować relację opartą na skali, przewidywalności i wzroście.",
      cta: "Porozmawiaj o przyszłej współpracy logistycznej",
    },
    finalCta: {
      label: "Porozmawiajmy",
      title: "Szukasz partnera, który rozumie logistykę produkcji?",
      body:
        "Jeżeli Twoja firma potrzebuje przewidywalnego partnera do transportu, spedycji, logistyki operacyjnej lub wsparcia ADR — porozmawiajmy. Dobierzemy model współpracy do Twoich procesów, wolumenów i wymagań branżowych.",
      cta1: "Skontaktuj się z nami",
      cta2: "Wyceń transport",
    },
    contact: {
      label: "Kontakt",
      title: "Skontaktuj się z LK LOG",
      subtitle:
        "Opowiedz nam o swoich potrzebach transportowych. Odpowiadamy zwykle w ciągu 24 godzin roboczych.",
      name: "Imię i nazwisko",
      email: "Adres e-mail",
      phone: "Telefon",
      company: "Firma",
      message: "Wiadomość",
      placeholder_message: "Kierunki, wolumen, częstotliwość, typ ładunku, wymagania ADR...",
      submit: "Wyślij wiadomość",
      sending: "Wysyłanie...",
      success: "Dziękujemy! Odezwiemy się wkrótce.",
      error: "Wystąpił błąd. Spróbuj ponownie lub zadzwoń bezpośrednio.",
      validation: "Uzupełnij wymagane pola (imię, e-mail, wiadomość).",
      people_title: "Zespół",
      address_title: "Adres",
      address_name: "LK LOG Karol Lewandowski",
      address_line1: "ul. Nieszawska 77",
      address_line2: "87-720 Ciechocinek",
      p1_name: "Przemysław Chudy",
      p1_role: "Dyrektor Spedycji / Transportu — Współwłaściciel",
      p1_phone: "+48 660 341 213",
      p1_email: "p.chudy@lklog.pl",
      p2_name: "Karol Lewandowski",
      p2_role: "Właściciel",
      p2_phone: "+48 501 613 583",
      p2_email: "k.lewandowski@lklog.pl",
    },
    footer: {
      tagline: "Kompleksowy partner logistyczny dla firm produkcyjnych i przemysłowych.",
      copyright: "Wszelkie prawa zastrzeżone.",
      sections: "Sekcje",
      contact: "Kontakt",
    },
  },
  en: {
    nav: {
      home: "Home",
      about: "About",
      services: "Services",
      industries: "Industries",
      adr: "ADR",
      solutio: "Solutio",
      contact: "Contact",
      cta: "Request a quote",
    },
    hero: {
      eyebrow: "Premium logistics · Poland & Europe",
      tagline: "Always on the right course",
      title: "Your comprehensive logistics partner",
      subtitle:
        "Transport, logistics, ADR consulting and legal support for manufacturing and industrial companies that demand punctual, flexible delivery operations across Poland and Europe.",
      cta1: "Request a quote",
      cta2: "Talk to us",
      usp1: "Domestic and international transport",
      usp2: "Own fleet and contracted carrier network",
      usp3: "Dedicated service for industrial clients",
      usp4: "ADR / DGSA consulting",
    },
    anniversary: {
      label: "2020 — 2026",
      title_pre: "Thank you for",
      title_big: "6 years",
      title_post: "of trust and partnership",
      line1: "Your goal — our mission",
      line2: "Transport — that's us",
      line3: "Together we make a great team",
    },
    about: {
      label: "About us",
      title: "Logistics built on experience, accountability and partnership",
      p1: "LK LOG is a trusted logistics partner specialising in end-to-end transport organisation across Poland and Europe. Since 2020 we have been growing our own fleet, operational facilities and network of contracted carriers — delivering reliable service both for steady flows and for irregular, seasonal or urgent shipments.",
      p2: "Behind the company stands a team with more than 30 years of combined experience in transport, warehousing and operations. We combine hands-on business know-how with a modern approach to transport management, supporting clients not only as a carrier, but as a real partner in their supply chain.",
      stat1_v: "2020",
      stat1_l: "Year we started building LK LOG",
      stat2_v: "30+",
      stat2_l: "Years of combined team experience",
      stat3_v: "PL · EU",
      stat3_l: "Full operational coverage",
      stat4_v: "24/7",
      stat4_l: "Dedicated operational support",
    },
    capabilities: {
      label: "Operational capacity",
      title: "A transport backbone ready for steady flows and fast responses",
      subtitle:
        "Our scalable operational backbone handles both regular supply chains and non-standard, project or ad-hoc shipments — for companies that expect punctuality, flexibility and full visibility.",
      c1_t: "Own operational fleet",
      c1_b1: "41 x 13.6m combinations",
      c1_b2: "~70% tipper (mulda) trailers",
      c1_b3: "11 vans 8/10 EP",
      c1_b4: "Seasonal dump trailers",
      c2_t: "Contracted carrier network",
      c2_d: "We work with a vetted group of partner carriers, allowing us to rapidly scale vehicle availability and maintain continuity of service during peak volumes.",
      c3_t: "Central operational control",
      c3_d: "Every order is supervised by a dedicated ops team. The client gets one point of contact, live oversight and a consistent standard of service.",
    },
    industries: {
      label: "Industries we serve",
      title: "We understand manufacturing, industry and distribution",
      subtitle:
        "We work with companies that need a partner who understands production rhythms, loading windows, stock buffering, volumetric transport and tight delivery schedules.",
      items: [
        { t: "Automotive", d: "Components, parts, assemblies, just-in-time and just-in-sequence deliveries." },
        { t: "Heavy industry & steel", d: "Steel coils, structural elements, oversized loads." },
        { t: "Agriculture & agro", d: "Fertilisers, grain, bulk and bagged materials." },
        { t: "Food & beverages", d: "Dry goods, semi-finished products, packaging." },
        { t: "FMCG", d: "Palletised loads, fast turnover and punctuality." },
        { t: "Furniture & oversized", d: "Deliveries to DCs and retail points." },
        { t: "Imports from Asia", d: "Containers, port handling, domestic and EU distribution." },
        { t: "Packaging & plastics", d: "Continuous service for production lines and warehouses." },
      ],
    },
    services: {
      label: "Services",
      title: "More than transport",
      s1_t: "Transport & forwarding",
      s1_d: "Domestic and international transport with flexible cooperation models tailored to manufacturing, trading and industrial clients.",
      s2_t: "Operational logistics",
      s2_d: "Planning and execution of supply chain flows, load coordination, distribution and non-standard transport operations.",
      s3_t: "ADR / DGSA consulting",
      s3_d: "Support for the transport of dangerous goods: documentation, audits, annual ADR reports, procedures and training.",
      s4_t: "Legal business support",
      s4_d: "Through Solutio — a law firm within LK LOG — we support businesses with legal services, debt recovery, restructuring, asset protection and formal matters.",
    },
    adr: {
      label: "ADR · DGSA",
      title: "ADR consulting — safety fully under control",
      body:
        "As a certified DGSA adviser, we provide full support in organising the transport of dangerous goods. We help reduce risk, ensure compliance with current regulations and keep operational documentation in order.",
      b1: "Consulting on the transport of dangerous goods",
      b2: "Annual ADR reports, documentation and audits",
      b3: "Training and procedure roll-outs",
      b4: "Risk reduction and regulatory compliance",
      cta: "Ask about ADR support",
    },
    solutio: {
      label: "Solutio",
      title: "Logistics and law within one structure",
      body:
        "Solutio is a law firm operating within LK LOG's business structure. As a result, our clients benefit not only from transport and logistics, but also from practical support in formal and legal areas that impact operational safety.",
      b1: "Legal services for companies",
      b2: "Debt recovery and receivables enforcement",
      b3: "Restructuring and crisis advisory",
      b4: "Asset protection and representation",
      cta: "Explore Solutio support",
    },
    why: {
      label: "Why LK LOG",
      title: "Why companies choose LK LOG",
      items: [
        { t: "Fleet flexibility and availability", d: "We combine our own transport backbone with a vetted carrier network, reacting fast to changing needs and scaling service without compromising quality." },
        { t: "Reliability and punctuality", d: "Every order is executed to defined operational standards, with live oversight and full accountability from pickup to delivery." },
        { t: "End-to-end service", d: "Transport, logistics, ADR and legal support within one structure — fewer risks, fewer touchpoints, higher predictability." },
        { t: "Understanding production environments", d: "We align with the rhythm of manufacturing sites, loading windows and JIT / JIS delivery models." },
        { t: "Partnership mindset", d: "We build long-term relationships: direct, transparent, solution-focused — genuinely supporting our clients' business." },
      ],
    },
    process: {
      label: "Process",
      title: "How working with LK LOG looks",
      steps: [
        { t: "Needs analysis", d: "We learn the specifics of your cargo, delivery frequency, lanes and operational expectations." },
        { t: "Service model design", d: "We match fleet, schedule, reporting and the level of operational engagement to your needs." },
        { t: "Execution and oversight", d: "We run the transport under live ops-team control with contact at every stage." },
        { t: "Cooperation growth", d: "We optimise the operating model as volumes, seasonality and your side of the business evolve." },
      ],
    },
    investment: {
      label: "Investment · Growth",
      title: "We are building our own logistics centre",
      body1:
        "As part of our long-term strategy, we are planning a logistics centre in the Ciechocinek region. The project includes modern warehouse space, a cross-dock zone and capacity for buffering and distribution models for manufacturers.",
      body2:
        "This is the path for clients who want to consolidate transport and logistics with a single partner and build a relationship based on scale, predictability and growth.",
      cta: "Let's talk about future cooperation",
    },
    finalCta: {
      label: "Let's talk",
      title: "Looking for a partner who understands production logistics?",
      body:
        "If your company needs a predictable partner for transport, forwarding, operational logistics or ADR support — let's talk. We will tailor the cooperation model to your processes, volumes and industry requirements.",
      cta1: "Get in touch",
      cta2: "Request a quote",
    },
    contact: {
      label: "Contact",
      title: "Get in touch with LK LOG",
      subtitle:
        "Tell us about your transport needs. We usually reply within 24 business hours.",
      name: "Full name",
      email: "Email address",
      phone: "Phone",
      company: "Company",
      message: "Message",
      placeholder_message: "Lanes, volume, frequency, cargo type, ADR requirements...",
      submit: "Send message",
      sending: "Sending...",
      success: "Thank you! We will get back to you shortly.",
      error: "Something went wrong. Please try again or call us directly.",
      validation: "Please fill in the required fields (name, email, message).",
      people_title: "Team",
      address_title: "Address",
      address_name: "LK LOG Karol Lewandowski",
      address_line1: "ul. Nieszawska 77",
      address_line2: "87-720 Ciechocinek, Poland",
      p1_name: "Przemysław Chudy",
      p1_role: "Director of Forwarding / Transport — Co-owner",
      p1_phone: "+48 660 341 213",
      p1_email: "p.chudy@lklog.pl",
      p2_name: "Karol Lewandowski",
      p2_role: "Owner",
      p2_phone: "+48 501 613 583",
      p2_email: "k.lewandowski@lklog.pl",
    },
    footer: {
      tagline: "A comprehensive logistics partner for manufacturing and industrial companies.",
      copyright: "All rights reserved.",
      sections: "Sections",
      contact: "Contact",
    },
  },
};
